var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-expander-card',{staticClass:"employee",attrs:{"imgSrc":_vm.imgSrc,"imgAlt":_vm.name,"imgRatio":"1x1"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }